/** Whether a popover or dialog (a cell editor, a picker's panel) is open anywhere on the page. */
export const hasOpenPopover = () =>
    document.querySelector("[role='dialog'][data-open]") !== null;
